import React from "react";
import { Card, Typography, Button, Empty } from "antd";
import { Link } from "react-router-dom";
import { Plus, Calculator } from "lucide-react";
import { v4 as uuidv4 } from "uuid";

const { Title, Paragraph } = Typography;

const PowerCalculatorList: React.FC = () => {
  // This would typically fetch saved calculations from an API
  const calculations: any[] = [];

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-6 md:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <div>
            <Title level={2} className="mb-2">
              <Calculator className="w-8 h-8 inline mr-3" />
              Power Calculations
            </Title>
            <Paragraph className="text-gray-600">
              Manage your statistical power calculations and experiment designs
            </Paragraph>
          </div>
          <Link to={`/power-calculator/${uuidv4()}`}>
            <Button
              type="primary"
              size="large"
              icon={<Plus className="w-4 h-4" />}
              className="bg-gradient-to-r from-blue-600 to-purple-600 border-none"
            >
              New Calculation
            </Button>
          </Link>
        </div>

        <Card className="shadow-sm">
          {calculations.length === 0 ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No power calculations yet"
            >
              <Link to={`/power-calculator/${uuidv4()}`}>
                <Button type="primary" icon={<Plus className="w-4 h-4" />}>
                  Create Your First Calculation
                </Button>
              </Link>
            </Empty>
          ) : (
            <div>
              {/* Future: Display list of saved calculations */}
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};

export default PowerCalculatorList;
